export const parkingMarkerIdSelector = ({parkingMarkerId}) => parkingMarkerId